var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
/* eslint-disable no-restricted-imports --
   편집 모드 전용 도구(운영자만 사용) — 계측 대상이 아니다.
   (터치 컴포넌트는 Scc* 사용 원칙: .eslintrc.js no-restricted-imports) */
import React, { useRef, useState, useCallback } from 'react';
import { View, Text, TouchableOpacity, ActivityIndicator } from 'react-native';
import styled from 'styled-components/native';
import { api } from '../../../config/api';
import { color } from '@/constant/color';
import ImageFileUtils from '@/utils/ImageFileUtils';
import { useResponsive } from '../context/ResponsiveContext';
export default function ImageUploader({ currentImageUrl, onUploadComplete, buttonText = '이미지 업로드', compact = false, }) {
    const { isDesktop } = useResponsive();
    const fileInputRef = useRef(null);
    const [isUploading, setIsUploading] = useState(false);
    const [error, setError] = useState(null);
    const handleButtonPress = useCallback(() => {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }, []);
    const handleFileSelect = useCallback((event) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file)
            return;
        // 파일 타입 검증
        if (!file.type.startsWith('image/')) {
            setError('이미지 파일만 업로드 가능합니다.');
            return;
        }
        // 파일 크기 검증 (10MB 제한)
        if (file.size > 10 * 1024 * 1024) {
            setError('파일 크기는 10MB 이하여야 합니다.');
            return;
        }
        setError(null);
        setIsUploading(true);
        const blobUrl = URL.createObjectURL(file);
        try {
            // 파일 확장자 추출
            const extension = ((_b = file.name.split('.').pop()) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || 'jpeg';
            const filenameExtension = extension === 'jpg' ? 'jpeg' : extension;
            // 이미지 업로드
            const uploadedUrl = yield ImageFileUtils.uploadWebImage(api, blobUrl, filenameExtension);
            // 콜백 호출
            onUploadComplete(uploadedUrl);
        }
        catch (err) {
            console.error('Image upload failed:', err);
            setError('업로드 실패. 다시 시도해주세요.');
        }
        finally {
            URL.revokeObjectURL(blobUrl);
            setIsUploading(false);
            // input 초기화 (같은 파일 재선택 가능하도록)
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    }), [onUploadComplete]);
    // Web용 file input change handler
    const handleInputChange = useCallback((e) => {
        handleFileSelect(e);
    }, [handleFileSelect]);
    if (compact) {
        return (_jsxs(CompactContainer, { children: [_jsx("input", { ref: fileInputRef, type: "file", accept: "image/*", onChange: handleInputChange, style: { display: 'none' } }), _jsx(CompactButton, { isDesktop: isDesktop, onPress: handleButtonPress, disabled: isUploading, children: isUploading ? (_jsx(ActivityIndicator, { size: "small", color: "#fff" })) : (_jsx(CompactButtonText, { isDesktop: isDesktop, children: "\uD83D\uDCF7" })) })] }));
    }
    return (_jsxs(Container, { children: [_jsx("input", { ref: fileInputRef, type: "file", accept: "image/*", onChange: handleInputChange, style: { display: 'none' } }), _jsx(UploadButton, { isDesktop: isDesktop, onPress: handleButtonPress, disabled: isUploading, children: isUploading ? (_jsx(ActivityIndicator, { size: "small", color: "#fff" })) : (_jsx(UploadButtonText, { isDesktop: isDesktop, children: buttonText })) }), error && _jsx(ErrorText, { children: error }), currentImageUrl && (_jsxs(CurrentImageInfo, { children: [_jsx(InfoText, { children: "\uD604\uC7AC \uC774\uBBF8\uC9C0 URL:" }), _jsx(UrlText, { numberOfLines: 1, children: currentImageUrl })] }))] }));
}
const Container = styled(View) `
  margin: 8px 0;
`;
const CompactContainer = styled(View) ``;
const UploadButton = styled(TouchableOpacity) `
  background-color: ${color.iosBlue};
  padding: ${({ isDesktop }) => (isDesktop ? '14px 24px' : '12px 20px')};
  border-radius: ${({ isDesktop }) => (isDesktop ? '10px' : '8px')};
  align-items: center;
`;
const UploadButtonText = styled(Text) `
  color: ${color.white};
  font-size: ${({ isDesktop }) => (isDesktop ? '16px' : '14px')};
  font-weight: 600;
`;
const CompactButton = styled(TouchableOpacity) `
  background-color: ${color.iosBlue}E6;
  width: ${({ isDesktop }) => (isDesktop ? '44px' : '36px')};
  height: ${({ isDesktop }) => (isDesktop ? '44px' : '36px')};
  border-radius: ${({ isDesktop }) => (isDesktop ? '22px' : '18px')};
  align-items: center;
  justify-content: center;
`;
const CompactButtonText = styled(Text) `
  font-size: ${({ isDesktop }) => (isDesktop ? '20px' : '16px')};
`;
const ErrorText = styled(Text) `
  color: ${color.danger};
  font-size: 12px;
  margin-top: 8px;
`;
const CurrentImageInfo = styled(View) `
  margin-top: 12px;
  padding: 8px;
  background-color: ${color.gray10};
  border-radius: 4px;
`;
const InfoText = styled(Text) `
  font-size: 12px;
  color: ${color.gray60};
  margin-bottom: 4px;
`;
const UrlText = styled(Text) `
  font-size: 11px;
  color: ${color.gray70};
  font-family: monospace;
`;
